import { Component, HostBinding, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../utils/services/api.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AppService, AuthUser } from '../utils/services/app.service';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  @HostBinding('class') public bodyClasses = 'hold-transition login-page';//sidebar-collapse
  public loginForm: FormGroup;

  constructor(private router: Router,
    private notificationService: NotificationsService,
    private apiService: ApiService,
    private appService: AppService) {
  }

  ngOnInit() {
    this.loginForm = new FormGroup({
      'email': new FormControl(null, Validators.required),
      'password': new FormControl(null, Validators.required)
    });
  }

  login() {
    if (this.loginForm.valid) {
      this.apiService.authenticate(this.loginForm.controls.email.value, this.loginForm.controls.password.value).subscribe(
        response => {
          if (response.data.user.userOrganization.type === 'BiziSystem') {
            this.appService.loginUser(
              response['data'].token.accessToken,
              response['data'].user.id,
              response['data'].user.organizationId);
          } else {
            this.notificationService.warn('You are not a BiziSystem user, you cannot login!');
          }

        }, error => {
          this.notificationService.error('Error', 'Login operation failed!');
        }
      );
    }
  }

}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/login/login.component.ts